// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionB_comp__NSexl"};